import { RuleOperators } from "../../constants/action-types";

export const filters = [
  {
    value: "filter_a_deal",
    label: "A deal",
    data: {
      type: "SALE",
      inputType: "SALE",
      outputType: "SALE",
      fieldPicker: true,
      fieldId: "",
      operator: "is",
      to: {},
      description: "A deal",
    },
  },
  {
    value: "filter_a_contact",
    label: "A contact",
    data: {
      type: "CONTACT",
      inputType: "CONTACT",
      outputType: "CONTACT",
      fieldPicker: true,
      fieldId: "",
      operator: "is",
      to: {},
      description: "A contact",
    },
  },
  {
    value: "filter_an_account",
    label: "An account",
    data: {
      type: "COMPANY",
      inputType: "COMPANY",
      outputType: "COMPANY",
      fieldPicker: true,
      fieldId: "",
      operator: "is",
      to: {},
      description: "An account",
    },
  },
  {
    value: "filter_an_activity",
    label: "An activity",
    data: {
      type: "ACTIVITY",
      inputType: "ACTIVITY",
      outputType: "ACTIVITY",
      fieldPicker: true,
      fieldId: "",
      operator: "is",
      to: {},
      description: "An activity",
    },
  },
];

export const events = [
  {
    value: "status_changes",
    label: "status changes",
    data: {
      type: "SALE",
      inputType: "SALE",
      outputType: "SALE",
      fieldId: "status",
      operator: RuleOperators.UPDATED_FIELD,
      description: "When Status changes",
      from: {},
      to: {},
    },
  },
  {
    value: "stage_changes",
    label: "stage changes",
    data: {
      type: "SALE",
      inputType: "SALE",
      outputType: "SALE",
      fieldId: "stage",
      operator: RuleOperators.UPDATED_FIELD,
      description: "When Stage changes",
      to: {},
    },
  },
  {
    value: "person_assigned",
    label: "person assigned",
    data: {
      type: "SALE",
      inputType: "SALE",
      outputType: "SALE",
      fieldId: "assignees",
      operator: RuleOperators.UPDATED_FIELD,
      description: "When person is assigned",
      to: {},
    },
  },
  {
    value: "sale_created",
    label: "sale created",
    data: {
      type: "SALE",
      inputType: "SALE",
      outputType: "SALE",
      operator: RuleOperators.NEW_SALE,
      description: "When a sale is created",
    },
  },
  {
    value: "contact_created",
    label: "contact created",
    data: {
      type: "CONTACT",
      inputType: "CONTACT",
      outputType: "CONTACT",
      operator: RuleOperators.NEW_CONTACT,
      description: "When a contact is created",
    },
  },
  {
    value: "contact_column_changes",
    label: "contact field changes",
    data: {
      type: "CONTACT",
      inputType: "CONTACT",
      outputType: "CONTACT",
      operator: RuleOperators.UPDATED_FIELD,
      fieldPicker: true,
      fieldId: "",
      to: {},
      description: "When contact field changes",
    },
  },
  {
    value: "company_created",
    label: "account created",
    data: {
      type: "COMPANY",
      inputType: "COMPANY",
      outputType: "COMPANY",
      operator: RuleOperators.NEW_COMPANY,
      description: "When an account is created",
    },
  },
  {
    value: "company_column_changes",
    label: "account field changes",
    data: {
      type: "COMPANY",
      inputType: "COMPANY",
      outputType: "COMPANY",
      operator: RuleOperators.UPDATED_FIELD,
      fieldPicker: true,
      fieldId: "",
      to: {},
      description: "When account field changes",
    },
  },
  {
    value: "product_created",
    label: "product created",
    data: {
      type: "PRODUCT",
      inputType: "PRODUCT",
      outputType: "PRODUCT",
      operator: RuleOperators.NEW_PRODUCT,
      description: "When a product is created",
    },
  },
  {
    value: "product_column_changes",
    label: "product field changes",
    data: {
      type: "PRODUCT",
      inputType: "PRODUCT",
      outputType: "PRODUCT",
      operator: RuleOperators.UPDATED_FIELD,
      fieldPicker: true,
      fieldId: "",
      to: {},
      description: "When product field changes",
    },
  },
  {
    value: "column_changes",
    label: "column changes",
    data: {
      type: "SALE",
      inputType: "SALE",
      outputType: "SALE",
      operator: RuleOperators.UPDATED_FIELD,
      fieldPicker: true,
      fieldId: "",
      to: {},
      description: "When columns changes",
    },
  },
  {
    value: "sale_moved_to_funnel",
    label: "sale moved to funnel",
    data: {
      type: "SALE",
      inputType: "SALE",
      outputType: "SALE",
      fieldId: "bucketId",
      operator: RuleOperators.UPDATED_FIELD,
      description: "When a sale is moved to funnel",
      to: {},
    },
  },
  {
    value: "jira:issue_created",
    label: "issue created",
    data: {
      type: "JIRA",
      inputType: "JIRA_ISSUE",
      outputType: "SALE",
      operator: RuleOperators.NEW_ISSUE,
      jql: "",
      description: "When an issue is created",
    },
  },
  {
    value: "user_created",
    label: "customer created",
    data: {
      type: "JIRA",
      inputType: "JIRA_CUSTOMER",
      outputType: "CONTACT",
      operator: RuleOperators.NEW_CONTACT,
      description: "When a customer is created",
    },
  },
  {
    value: "user_updated",
    label: "customer updated",
    data: {
      type: "JIRA",
      inputType: "JIRA_CUSTOMER",
      outputType: "CONTACT",
      operator: RuleOperators.UPDATED_CONTACT,
      description: "When a customer is updated",
    },
  },
  {
    value: "jsm_request",
    label: "JSM Request",
    data: {
      type: "JSM",
      inputType: "JSM_REQUEST",
      outputType: "SALE",
      description: "When a new request from JSM",
    },
  },
  {
    value: "hubspot_incoming_webhook",
    label: "Incoming Hubspot Webhook",
    data: {
      type: "HUBSPOT",
      inputType: "HUBSPOT_CONTACT",
      outputType: "SALE",
      webhookConnected: false,
      webhookPayload: {},
      operator: RuleOperators.UPDATED_CONTACT,
      description: "When a webhook from Hubspot ",
    },
  },
  {
    value: "SCHEDULED",
    label: "Every hour",
    data: {
      type: "SCHEDULED",
      inputType: "SCHEDULED",
      outputType: "SCHEDULED",
      interval: "hour",
      operator: RuleOperators.SCHEDULED,
      description: "Every hour (scheduled) — GTM sequence and other timed automations",
    },
  },
];

export const actions = [
  {
    value: "move_sale_to_funnel",
    label: "move sale to funnel",
    data: {
      type: "SALE",
      inputType: "SALE",
      outputType: "SALE",
      operator: RuleOperators.SET_FIELD,
      fieldId: "bucketId",
      description: "Then set Funnel",
      to: {},
    },
  },
  {
    value: "change_status",
    label: "change status",
    data: {
      type: "SALE",
      inputType: "SALE",
      outputType: "SALE",
      operator: RuleOperators.SET_FIELD,
      fieldId: "status",
      description: "Then set Status",
      to: {},
    },
  },
  {
    value: "assign_person",
    label: "assign person",
    data: {
      type: "SALE",
      inputType: "SALE",
      outputType: "SALE",
      operator: RuleOperators.SET_FIELD,
      fieldId: "assignees",
      description: "Then Assign (replace)",
      from: {},
      to: {},
    },
  },
  {
    value: "clear_assignees",
    label: "clear assignees",
    data: {
      type: "SALE",
      inputType: "SALE",
      outputType: "SALE",
      operator: RuleOperators.SET_FIELD,
      fieldId: "assignees",
      description: "Then unassign an assignee",
      from: {},
    },
  },
  // SET_FIELD with fieldPicker: works for SALE, CONTACT, COMPANY, PRODUCT (inputType set from chain in RuleItemBuilder)
  {
    value: "update_column_to",
    label: "update column to",
    data: {
      type: "SALE",
      inputType: "",
      outputType: "",
      operator: RuleOperators.SET_FIELD,
      fieldPicker: true,
      fieldId: "",
      description: "Set column to a value",
      to: {},
    },
  },
  {
    value: "update_column_from_to",
    label: "update column from a value to something",
    data: {
      type: "SALE",
      inputType: "",
      outputType: "",
      operator: RuleOperators.SET_FIELD,
      fieldPicker: true,
      fieldId: "",
      description: "Set column from a value to something",
      from: {},
      to: {},
    },
  },
  {
    value: "send_to_slack_channel",
    label: "Send to Slack channel",
    data: {
      type: "SLACK",
      inputType: "SALE",
      outputType: "SALE",
      operator: RuleOperators.SEND_TO_SLACK_CHANNEL,
      channelId: "",
      channelName: "",
      description: "Send to Slack channel",
      message: "",
    },
  },
  {
    value: "send_email",
    label: "Send email",
    data: {
      type: "EMAIL",
      inputType: "SALE",
      outputType: "SALE",
      operator: RuleOperators.SEND_EMAIL,
      sender: "",
      receivers: "",
      subject: "",
      body: "",
      description: "Send email",
    },
  },
  {
    value: "convert_contact_to_new_sale",
    label: "convert to a sale",
    data: {
      type: "CONTACT",
      inputType: "CONTACT",
      outputType: "SALE",
      mappings: { sale: [], contact: [], account: [] },
      operator: RuleOperators.CONTACT_2_NEW_SALE,
      description: "Then convert a contact to a sale",
    },
  },
  {
    value: "convert_issue_to_new_sale",
    label: "convert to a sale",
    data: {
      type: "JIRA",
      inputType: "JIRA_ISSUE",
      outputType: "SALE",
      operator: RuleOperators.ISSUE_2_NEW_SALE,
      description: "Then convert an Issue to a sale",
    },
  },
  {
    value: "convert_customer_to_contact",
    label: "convert to a contact",
    data: {
      type: "JIRA",
      inputType: "JIRA_CUSTOMER",
      outputType: "CONTACT",
      operator: RuleOperators.JIRA_CUSTOMER_2_NEW_CONTACT,
      description: "Then convert a customer to a contact",
    },
  },
  {
    value: "convert_hubspot_contact_to_sale",
    label: "convert to a contact",
    data: {
      type: "HUBSPOT",
      inputType: "HUBSPOT_CONTACT",
      outputType: "SALE",
      mappings: { sale: [], contact: [], account: [] },
      operator: RuleOperators.HUBSPOT_2_NEW_SALE,
      description: "Then convert a Hubspot contact to sale/contact/account",
    },
  },
  {
    value: "convert_jsm_request_to_sale",
    label: "convert to a JSM request",
    data: {
      type: "JSM",
      inputType: "JSM_REQUEST",
      outputType: "SALE",
      mappings: { sale: [], contact: [], account: [] },
      operator: RuleOperators.HUBSPOT_2_NEW_SALE,
      description: "Then convert a JSM request to sale/contact/account",
    },
  },
  {
    value: "mailchimp_sync_contact",
    label: "Sync contact to Mailchimp",
    data: {
      type: "MAILCHIMP",
      inputType: "SALE",
      outputType: "SALE",
      operator: RuleOperators.MAILCHIMP_SYNC_EMAILS,
      workflowId: "",
      workflowName: "",
      description: "Then sync contact to Mailchimp to list #",
    },
  },
  {
    value: "contact2mailchimp_sync_contact",
    label: "Sync contact to Mailchimp",
    data: {
      type: "MAILCHIMP",
      inputType: "CONTACT",
      outputType: "CONTACT",
      operator: RuleOperators.MAILCHIMP_SYNC_EMAILS,
      workflowId: "",
      workflowName: "",
      description: "Then sync contact to Mailchimp to list #",
    },
  },
  {
    value: "ai_field_research",
    label: "Research record",
    data: {
      type: "AI_FIELD",
      operator: RuleOperators.AI_FIELD,
      aiFieldAction: "researchRecord",
      questions: [],
      description: "Then research record (AI)",
    },
  },
  {
    value: "ai_field_summarize",
    label: "Summarize record",
    data: {
      type: "AI_FIELD",
      operator: RuleOperators.AI_FIELD,
      aiFieldAction: "summarizeRecord",
      guidance: "",
      targetAudience: "",
      description: "Then summarize record (AI)",
    },
  },
  {
    value: "ai_field_classify_record",
    label: "Classify record",
    data: {
      type: "AI_FIELD",
      operator: RuleOperators.AI_FIELD,
      aiFieldAction: "classifyRecord",
      tags: [],
      allowMultiple: false,
      description: "Then classify record (AI)",
    },
  },
  {
    value: "ai_field_classify_text",
    label: "Classify text",
    data: {
      type: "AI_FIELD",
      operator: RuleOperators.AI_FIELD,
      aiFieldAction: "classifyText",
      text: "",
      tags: [],
      allowMultiple: false,
      description: "Then classify text (AI)",
    },
  },
  {
    value: "ai_field_prompt_completion",
    label: "Prompt completion",
    data: {
      type: "AI_FIELD",
      operator: RuleOperators.AI_FIELD,
      aiFieldAction: "promptCompletion",
      prompt: "",
      description: "Then prompt completion (AI)",
    },
  },
  {
    value: "advance_gtm_sequence",
    label: "Advance GTM sequence",
    data: {
      type: "SCHEDULED",
      inputType: "SCHEDULED",
      outputType: "SCHEDULED",
      operator: RuleOperators.ADVANCE_GTM_SEQUENCE,
      description: "Then advance due LinkedIn sequence enrollments (GTM)",
    },
  },
];

export function isManagedByApp(app: string): boolean {
  switch (app) {
    case "convert_jsm_request_to_sale":
    case "convert_hubspot_contact_to_sale":
    case "jsm_request":
    case "hubspot_incoming_webhook":
      return true;
    default:
      return false;
  }
}
